module.exports = __webpack_public_path__ + "78241f63b11afa47c900c0371483996b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2070_teaser_image.jpg
// module id = 585
// module chunks = 0